import { Link } from 'react-router'
import { notFoundTexts } from '../common/texts'
import { paths } from '../paths'

export function NoMatchPage() {
  return (
    <div className="flex flex-column align-items-center p-4">
      <h2>{notFoundTexts.title}</h2>
      <p>{notFoundTexts.message}</p>
      <Link to={paths.home} className="p-button p-button-text">{notFoundTexts.backToHome}</Link>
    </div>
  )
}
